var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.loading ? 'loading' : 'loading loaded']},[_c('img',{attrs:{"src":"/imgs/loading.gif","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }